import ErrorTriangle from './ErrorTriangle';

export default ErrorTriangle;
